<order-request-main-request-list [requests]="transformedList"
  [article]="article"
  [workflow]="workflow"
  (requestToOrderEmitter)="requestToOrderEmitter.emit($event)">
</order-request-main-request-list>

@if (list) {
  <ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
}
